import SideMenu from '@/containers/side-menu/SideMenu.vue';
import FinancialAccount from '@/pages/financial-account/FinancialAccount.vue';

export default {
  path: '/register-financial-account',
  name: 'FinancialAccount',
  components: {
    mainContent: FinancialAccount,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'register-financial-account',
    },
    breadcrumb: {
      title: 'Contas',
      paths: [{ title: 'Gerenciamento' }],
    },
  },
};
